<template>
  <IonToolbar color="white" class="border-b-2 border-gray-300">
    <HeaderBackButton @click.stop="goBackToNetwork">Network</HeaderBackButton>
    <div class="text-2xl text-gray-900 font-bold">{{ deviceName }}</div>
  </IonToolbar>
</template>

<script setup lang="ts">
import HeaderBackButton from '@/components/forms/HeaderBackButton.vue';
import { useSelectedProperty } from '@/stores/selected-property.store';
import { useRoute } from 'vue-router';
import { IonToolbar, useIonRouter } from '@ionic/vue';
import { computed } from 'vue';
import { DeviceTypeHelper } from '@ncss/models';

const router = useIonRouter();
const route = useRoute();
const selectedProperty = useSelectedProperty();

const deviceName = computed(() => {
  if (route.params.repeaterId) {
    return DeviceTypeHelper.GetClientFacingNameBySerialNumber(+route.params.repeaterId);
  }
  return 'Repeater';
});

function goBackToNetwork() {
  return router.navigate(`/network/${selectedProperty.propertyId}`, 'back', 'push');
}
</script>

<style scoped></style>
